import { Card, Col, Row, Typography } from "antd";
import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

const { Title, Text } = Typography;

interface SourceConfig {
  key: string;
  name: string;
  enabled: boolean;
}

const SOURCES: SourceConfig[] = [
  { key: "linkedin", name: "LinkedIn", enabled: true },
  { key: "reddit", name: "Reddit", enabled: false },
];

export const SourceList: React.FC = () => {
  const history = useHistory();
  const { url } = useRouteMatch();

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>Recipe Sources</Title>
      <Text type="secondary">Select a source to manage its recipes.</Text>
      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        {SOURCES.map(source => (
          <Col key={source.key} xs={24} sm={12} md={8} lg={6}>
            <Card
              hoverable={source.enabled}
              onClick={() => {
                if (source.enabled) {
                  history.push(`${url}/${source.key}`);
                }
              }}
              style={{
                opacity: source.enabled ? 1 : 0.4,
                cursor: source.enabled ? "pointer" : "not-allowed",
              }}
            >
              <Title level={4}>{source.name}</Title>
              <Text type="secondary">
                {source.enabled ? "Click to manage recipes" : "Coming soon"}
              </Text>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};
